import { CancelTokenSource } from "axios";
import {
  BlockProcedureExtResponse,
  InterventionDto,
  InterventionSearchDto,
  UpsertInterventionDto
} from "ts-types/api.types";
import axios from "./http";

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUri = `${baseUrl}/api/interventions`;

export const getAllInterventions = (
    source: CancelTokenSource): Promise<Array<InterventionDto>> => {

  return getInterventions(true, source);
};

export const getActiveInterventions = (
    source: CancelTokenSource): Promise<Array<InterventionDto>> => {

  return getInterventions(false, source);
};

export const getInterventions = (
    includeInactive: boolean,
    source: CancelTokenSource): Promise<Array<InterventionDto>> => {

  return axios
      .get(apiUri, { params: {includeInactive: includeInactive}, cancelToken: source.token })
      .then(response => response.data);
};

export const searchInterventions = (interventionsSearchRequest: Partial<InterventionSearchDto>,
                                source: CancelTokenSource): Promise<Array<InterventionDto>> => {
  return axios
      .post(`${apiUri}/search`,interventionsSearchRequest, {cancelToken: source.token})
      .then(response => response.data)
};

export const getAllBlockProcedures = (
    source: CancelTokenSource): Promise<{[id: number]: BlockProcedureExtResponse}> => {

  return axios
      .get(`${apiUri}/block-procedures`, { cancelToken: source.token })
      .then(response => response.data);
};

export const findInterventionById = (
    id: number, source: CancelTokenSource): Promise<UpsertInterventionDto> => {

  return axios
    .get(`${apiUri}/${id}`, { cancelToken: source.token })
    .then(response => response.data);
};

export const addIntervention = (
    upsertInterventionDto: Partial<UpsertInterventionDto>,
    source: CancelTokenSource)
    : Promise<InterventionDto> => {

  return axios
      .post(apiUri, upsertInterventionDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editIntervention = (
    id: number,
    upsertInterventionDto: Partial<UpsertInterventionDto>,
    source: CancelTokenSource)
    : Promise<InterventionDto> => {

  return axios
      .put(`${apiUri}/${id}`,upsertInterventionDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const deleteIntervention = (
    id: number, source: CancelTokenSource)
    : Promise<number> => {

  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};
